<template>
  <b-modal
    id="modal-detail-historical-actual"
    size="xl"
    :title="`Historical Log Detail Actual - ${activity}`"
    @hide="resetModal()"
    @show="showModal()"
    hide-footer
  >
    <div class="container-fluid">
      <div v-if="isLoading" class="row mb-3">
        <!-- Skeleton loader, misalnya tampilkan placeholder -->
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <!-- Tambahkan skeleton untuk seluruh konten yang memerlukan data -->
      </div>

      <div v-else>
        <!-- Bagian Header -->
        <div class="card">
          <div class="card-body">
            <h4>Activity Description</h4>
            <p>{{ logData?.activity_description }}</p>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">Detail Actual</h4>
          </div>
          <div class="card-body">
            <div class="row row-cols-1 row-cols-md-4 g-4">
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Department</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.detailBudgetTask?.department_org_chart_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          ` ${detail?.detailBudgetTask?.plan_title} version ${detail?.detailBudgetTask?.plan_version} ${detail?.detailBudgetTask?.plan_year}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Type</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.detailBudgetTask?.budget_type }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL Name</h4>
                    <small class="text-body-secondary"
                      ><span> {{ ` ${detail?.detailBudgetTask?.gl_code} - ${detail?.detailBudgetTask?.account_name}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.detailBudgetTask?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PR Name</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.po_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PR Number</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.pr_number }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PR Date</h4>
                    <small class="text-body-secondary"
                      ><span> {{ formatDate(detail?.pr_date, false) }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-dollar-sign"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PR Value</h4>
                    <small class="text-body-secondary"
                      ><span> {{ formatCurrency(detail?.pr_value) || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PO Number</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.po_number || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PO Date</h4>
                    <small class="text-body-secondary"
                      ><span> {{ formatDate(detail?.po_date, false) }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-dollar-sign"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">PO Value</h4>
                    <small class="text-body-secondary"
                      ><span> {{ formatCurrency(detail?.po_value) || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Contract Name</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.contract_name || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Contract Detail</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.contract_detail_name || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Project Tag</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.project_tag || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Internal Memo</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.im_number || '-' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Status</h4>
                    <small class="text-body-secondary"
                      ><span> {{ detail?.status == 'Closed' ? 'Closed' : 'Open' }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">{{ titleCase(`${activity}d at`) }}</h4>
                    <small class="text-body-secondary"
                      ><span> {{ formatDate(logData?.created_at) }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">{{ titleCase(`${activity}d by`) }}</h4>
                    <small class="text-body-secondary"
                      ><span> {{ logData?.createdUser?.fullname }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Update Value Section -->
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">Detail Changes</h4>
          </div>
          <div class="card-body">
            <div v-for="(field, key) in comparisonData" :key="key" class="row align-items-center mb-2">
              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-warning p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>Old Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.old_value }}</p>
                </div>
              </div>

              <div class="col-md-2 text-center">
                <i class="fe fe-arrow-right fs-3 text-primary"></i>
              </div>

              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-info p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>New Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.new_value }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axiosIns from '@/api/axios';
import { formatCurrency } from '@/utils/formatNumber';
import moment from 'moment';

export default {
  props: {
    logId: Number,
    activity: String,
  },
  computed: {
    detail() {
      return this.logData?.oldData;
    },
  },
  data() {
    return {
      isLoading: true, // To show skeleton loader
      logData: {}, // To store the log data from API
      comparisonData: {}, // Store comparison of old and new values
    };
  },
  methods: {
    async showModal() {
      await this.fetchHistoricalLog();
    },
    resetModal() {
      this.logData = {}; // Reset the log data
      this.comparisonData = {}; // Reset the comparison data
      this.isLoading = true; // Reset loading state
    },
    async fetchHistoricalLog() {
      if (!this.logId) return;
      this.resetModal();
      await axiosIns
        .get(`/historical-log/${this.logId}`)
        .then((response) => {
          const data = response.data.data;
          this.logData = data.detail;
          this.logData.data_changes = data.data_changes;
          this.comparisonData = this.getComparisonData(data.data_changes.old_value, data.data_changes.new_value);
          this.isLoading = false; // Set loading state to false when data is fetched
        })
        .catch((error) => {
          this.isLoading = true; // Stop loading if error occurs
          this.$swal('Error', error.response?.data?.error || 'Terjadi kesalahan, tidak dapat mengambil data.', 'error');
          this.resetModal();
          console.error('Error fetching historical log details:', error);
        });
    },
    formatDate(date, withTime = true) {
      if (withTime) {
        return date ? moment(date).format('DD MMMM YYYY HH:mm') : '-';
      }
      return date ? moment(date).format('DD MMMM YYYY') : '-';
    },
    formatCurrency(value) {
      return formatCurrency(value, 'Rp.') || '-';
    },
    getComparisonData(old_value, new_value) {
      // Memastikan old_value dan new_value bukan undefined atau null
      const oldValue = old_value || {};
      const newValue = new_value || {};

      const filterKeysMapping = (keys) => {
        return keys
          .filter(
            (key) =>
              !key.includes('id') && !key.includes('code_plan_budget') && !key.includes('code_actual_budget') && !key.includes('actual_budget_item')
          )
          .map((key) => {
            let transformedKey = key;
            if (transformedKey.includes('subject')) {
              transformedKey = transformedKey.replace(/subject/gi, 'number');
            }
            transformedKey = transformedKey.replace(/(po|pr|im|gl)/gi, (match) => match.toUpperCase());
            if (key == 'po_name') {
              transformedKey = 'PR Name';
            }
            if (key == 'im_number') {
              transformedKey = 'Internal Memo';
            }
            if (key == 'project_tag') {
              transformedKey = 'Project Tag';
            }
            return {
              original: key,
              transformed: transformedKey,
            };
          });
      };

      // Contoh pemakaian di kode pembanding data:
      const result = {};
      const oldMappings = filterKeysMapping(Object.keys(oldValue));
      const newMappings = filterKeysMapping(Object.keys(newValue));

      // Iterasi key dari oldValue
      oldMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        result[formattedKey] = {
          old_value: oldValue[mapping.original] || '-',
          new_value: newValue[mapping.original] || '-',
        };
      });

      // Tambahkan key yang ada di newValue tapi tidak di oldValue
      newMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        if (!result.hasOwnProperty(formattedKey)) {
          result[formattedKey] = {
            old_value: oldValue[mapping.original] || '-',
            new_value: newValue[mapping.original] || '-',
          };
        }
      });

      return result;
    },
    // Fungsi untuk mengubah key (mengganti "_" menjadi spasi dan kapitalisasi setiap kata)
    formatKey(key) {
      return key
        .replace(/_/g, ' ') // Ganti _ dengan spasi
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Kapitalisasi setiap awal kata
    },
    titleCase(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style>
.skeleton-loader {
  background-color: #e0e0e0;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}
</style>
